import {Methods} from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectTestQuestionNewApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-test-question-new'
  }
  
  public saveRemark(params){
      return this.send(params,"saveRemark",Methods.POST)
  }


    public getEntityById(id){
        return this.send({id:id},"getEntityById",Methods.GET)
    }

    async getChiefEngineerMess() {
        return this.send({},"getChiefEngineerMess",Methods.GET)
    }
}